import { debounce } from '../_helpers/debounce';
import { mobileCheck } from '../_helpers/mobile-check';

window.addEventListener('load', event => {

    let checkMobile = mobileCheck(); // Call mobileCheck after window has loaded

    const vhFix = () => {
        // IOS VH Fix
        // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
        let vh = window.innerHeight * 0.01;
        // Then we set the value in the --vh custom property to the root of the document
        document.documentElement.style.setProperty('--vh', `${vh}px`);
    };

    const resizeDebounce = debounce(function() {
        vhFix();
    });

    const resizeListener = () => {
        resizeDebounce();
    };

    vhFix(); // Initialise vh fix on window load
    window.addEventListener('resize', resizeListener); // Initialize resize listener to recalculate vh on resize

    // Function that returns if device is ios (true/false)
    function iOS() {
        return [ 'iPad Simulator',
            'iPhone Simulator',
            'iPod Simulator',
            'iPad',
            'iPhone',
            'iPod'
        ].includes(navigator.platform)
            // iPad on iOS 13 detection
        || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
    }

    // Checks for mobile
    if (iOS) {
        document.body.classList.add('ios');
    }

    if (checkMobile) {
        document.body.classList.add('mobile-device');
    }
});
